import moment from "moment";
import useTranslator from "../../hooks/useTranslator";
import { getUserDisplayName, haveValue } from "../../helper/common";
import { useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LandLordContext from "../../context/landlord/LandLordContext";
import { Badge, Button, Icon } from "../design";

const STATUS_TONE = { completed: "lime", pending: "warning" };

const CreditsRow = ({ data }) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { workspaceId } = useParams();
  const { getCreditInvoice } = useContext(LandLordContext);
  const [loadingInvoice, setLoadingInvoice] = useState(false);

  const handleOpenProfile = () => {
    navigate(
      `/${workspaceId}/profile-property?sharedprofileid=${data?.opened_profile_id?._id}`
    );
  };

  const handleDownloadInvoice = async () => {
    setLoadingInvoice(true);
    try {
      const response = await getCreditInvoice(data?._id);
      if (response?.success && response?.success_res?.invoice_url) {
        const invoiceUrl = `${response.success_res.invoice_url}`;
        window.open(invoiceUrl, "_blank");
      }
    } catch (err) {
      console.error("Error downloading invoice:", err);
    } finally {
      setLoadingInvoice(false);
    }
  };
  const hasInvoice =
    data?.status !== "pending" &&
    data?.type === "credit" &&
    data?.metadata?.source !== "admin_add_credit";
  const landlordName = [
    data?.landlord_id?.fname_companyName,
    data?.landlord_id?.lname,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <tr>
      <td>
        <Badge tone={data?.type === "credit" ? "lime" : "neutral"}>
          {_t(data?.type) ?? "-"}
        </Badge>
      </td>
      <td>{data?.credit ?? "-"}</td>
      <td>{data?.amount ?? "-"}</td>
      <td>
        {data?.status ? (
          <Badge tone={STATUS_TONE[data.status] ?? "neutral"}>
            {_t(data.status)}
          </Badge>
        ) : (
          "-"
        )}
      </td>
      <td>
        {haveValue(data?.opened_profile_id?._id) ? (
          <Button variant="link" onClick={handleOpenProfile}>
            {getUserDisplayName(data?.opened_profile_id?.tenant_id, "-")}
          </Button>
        ) : (
          "-"
        )}
      </td>
      <td>{landlordName || "-"}</td>
      <td className="credits-table__date">
        {data?.processing_date
          ? moment(data.processing_date).format("DD MMMM YYYY, HH:mm")
          : "-"}
      </td>
      <td className="credits-table__invoice">
        {hasInvoice ? (
          <Button
            variant="ghost"
            size="md"
            iconOnly
            aria-label={_t("downloadInvoice")}
            title={_t("downloadInvoice")}
            iconStart={<Icon name="download" />}
            loading={loadingInvoice}
            onClick={handleDownloadInvoice}
          />
        ) : (
          "-"
        )}
      </td>
    </tr>
  );
};

export default CreditsRow;
